export default [
  {
    path: '/trainingList',
    name: 'trainingList',
    meta: {
      title: '培训资料'
    },
    component: () => import(/* webpackChunkName:'driverTest' */ './index.vue')
  }
];
